import permissions from '@/enums/permissions';

const socialContractsRouter = [
    {
        path: '/contratos-sociais',
        name: 'social-contracts',
        component: () => import('@/views/pages/SocialContracts/SocialContracts.vue'),
        meta: {
            permissions: permissions.socialContracts,
        },
    },
];

export default socialContractsRouter;
